<template class="user">
  <section class="section user">

    <div class="container user-content">

      <div class="container" id="user-workout-table-container">
        <h1 class="title is-5 has-text-centered">Timer på {{studioName}}:</h1>
        <br>
        <label class="title is-6"  id="user-table-label">I dag</label>
        <table class="table center is-hoverable">

          <tbody v-for="workout in workouts_sorted_date" v-if="isToday(workout.date) && isStudio(workout.studio.name)">
            <tr>
              <th id="user-workout-table-row-date">{{workout.date | formatDate}}</th>
              <th id="user-workout-table-row-time">kl. {{workout.time}}</th>
              <td id="user-workout-table-row-duration">{{workout.duration}} min</td>
              <td id="user-workout-table-row-name">{{workout.name}}</td>
              <td id="user-workout-table-row-studio">{{workout.studio.name}}</td>
              <td id="user-workout-table-row-type">{{workout.type}}</td>
              <td id="user-workout-table-row-btn"><button @click="showUsersModal(workout)" class="button is-success">Vis deltakere</button></td>
            </tr>
          </tbody>
        </table>
        <br>

        <label class="title is-6" id="user-table-label">I morgen</label>
        <table class="table center is-hoverable">
          <tbody v-for="workout in workouts_sorted_date" v-if="isTomorrow(workout.date) && isStudio(workout.studio.name)">
            <tr>
              <th id="user-workout-table-row-date">{{workout.date | formatDate}}</th>
              <th id="user-workout-table-row-time">kl. {{workout.time}}</th>
              <td id="user-workout-table-row-duration">{{workout.duration}} min</td>
              <td id="user-workout-table-row-name">{{workout.name}}</td>
              <td id="user-workout-table-row-studio">{{workout.studio.name}}</td>
              <td id="user-workout-table-row-type">{{workout.type}}</td>
              <td id="user-workout-table-row-btn"><button @click="showUsersModal(workout)" class="button is-success">Vis deltakere</button></td>
            </tr>
          </tbody>
        </table>
        <br>

        <label class="title is-6"  id="user-table-label">Fremtidige timer</label>
        <table class="table center is-hoverable">
          <tbody v-for="workout in workouts_sorted_date" v-if="notThisWeek(workout.date) && isStudio(workout.studio.name)">
            <tr>
              <th id="user-workout-table-row-date">{{workout.date | formatDate}}</th>
              <th id="user-workout-table-row-time">kl. {{workout.time}}</th>
              <td id="user-workout-table-row-duration">{{workout.duration}} min</td>
              <td id="user-workout-table-row-name">{{workout.name}}</td>
              <td id="user-workout-table-row-studio">{{workout.studio.name}}</td>
              <td id="user-workout-table-row-type">{{workout.type}}</td>
              <td id="user-workout-table-row-btn"><button @click="showUsersModal(workout)" class="button is-success">Vis deltakere</button></td>
            </tr>
          </tbody>
        </table>
        <br>
      </div>

      <div class="modal" :class="{ 'is-active': usersModal}">
        <div class="modal-background" @click="usersModal = false"></div>
        <div class="modal-card">
          <section class="modal-card-body">
            <h1 class="title is-4" v-for="attendee in activeWorkout.attendees">{{attendee}}</h1>
            <button @click="usersModal = false" class="button is-neutral unbook-btn">Lukk</button>
          </section>
        </div>
      </div>

    </div>


  </section>
</template>

<script>
import Firebase from 'firebase'

export default {
  data(){
    return {
      user: '',
      isAdmin: '',

      workouts: '',

      studioName: '',

      usersModal: false,
      activeWorkout: '',

    }
  },
  methods: {
    isStudio: function(name){
      return name === this.studioName;
    },
    showUsersModal: function(workout){
      this.activeWorkout = workout;
      this.usersModal = true;
    },
    isToday: function(workoutDay){
      var date = new Date();
      var dd = date.getDate();
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();
      if (mm < 10) {mm = '0'+mm};
      if (dd < 10) {dd = '0'+dd};
      var todaysDate = yyyy+'-'+mm+'-'+dd;

      if(workoutDay === todaysDate) { return true };
    },
    isTomorrow: function(workoutDay) {
      var date = new Date();
      date.setDate(date.getDate()+1);
      var dd = date.getDate();
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();
      if (mm < 10) {mm = '0'+mm};
      if (dd < 10) {dd = '0'+dd};
      var tomorrowsDate = yyyy+'-'+mm+'-'+dd;

      if(workoutDay === tomorrowsDate) { return true };
    },


    notThisWeek: function(workoutDay) {
      var date = new Date();
      date.setDate(date.getDate()+1);
      var dd = date.getDate();
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();
      if (mm < 10) {mm = '0'+mm};
      if (dd < 10) {dd = '0'+dd};
      var seventhdayDate = yyyy+'-'+mm+'-'+dd;

      if(workoutDay > seventhdayDate) { return true };
    },
  },
  created: function() {

    const db = Firebase.database();
    const userId = Firebase.auth().currentUser.uid;

    this.user_id = userId;


    //Get current users info
    Firebase.database().ref('users/'+userId+'/studioAdmin').on('value', snapshot => {
      var studioAdmin = snapshot.val();
      this.studioName = studioAdmin.name;
    });

    //Get users workouts attended
    Firebase.database().ref('workouts/').on('value', snapshot => {
      this.workouts = snapshot.val();
    });

  /*  Firebase.database().ref('users/'+userId+'/hasPaid').on('value', snapshot => {
      if(snapshot.val() != true) {window.location.replace('https://combine.no'+'/order/')};
    }); */


  },
  computed: {
    workouts_sorted_date: function() {
      return _.orderBy(this.workouts, 'date')
    },
  },
  filters: {
    formatDate: function (date) {
      var day = date[8]+date[9];
      var month = date[5]+date[6];
      return day+'/'+month;
    }
  },


}
</script>

<style lang="scss">


.user{
  background-color: #F5F7F9;
  min-height: 1200px;
  font-family: 'Lato', sans-serif;
}

.user-content{
  padding-top: 120px;
  margin: auto;

}
.table.center{
  box-shadow: 9px 8px 12px rgba(0, 0, 0, 0.04);
  margin-left:auto;
  margin-right:auto;
}
#user-table-label{
  padding-left: 190px;
  font-size: 20px;
}

#user-workout-table-head{
  color: #656464;
}
#user-workout-title{
  text-align: center;
}
.user-title {
  font-family: 'Lato', sans-serif;
  font-weight: 800;
}
.user-workout-column{
  font-family: 'Lato', sans-serif;
  font-size: 14px;
}
#user-workout-table-container{
  margin: auto;
}
#user-workout-table-row{
  border-bottom-width: 1px;
  border-color: #DEDEDE;
  font-size: 16px;
  font-weight: 500;
  padding-top: 20px;
  padding-bottom: 0px;
}
#user-workout-table-row-date{
  border-bottom-width: 1px;
  border-color: #DEDEDE;
  font-size: 16px;
  font-weight: 500;
  padding-top: 20px;
  padding-bottom: 0px;
  width: 90px;
}
#user-workout-table-row-time{
  border-bottom-width: 1px;
  border-color: #DEDEDE;
  font-size: 16px;
  font-weight: 500;
  padding-top: 20px;
  padding-bottom: 0px;
  width: 100px;
}
#user-workout-table-row-duration{
  border-bottom-width: 1px;
  border-color: #DEDEDE;
  font-size: 16px;
  font-weight: 500;
  padding-top: 20px;
  padding-bottom: 0px;
  width: 90px;
}
#user-workout-table-row-name{
  border-bottom-width: 1px;
  border-color: #DEDEDE;
  font-size: 16px;
  font-weight: 500;
  padding-top: 20px;
  padding-bottom: 0px;
  width: 260px;
}
#user-workout-table-row-studio{
  border-bottom-width: 1px;
  border-color: #DEDEDE;
  font-size: 16px;
  font-weight: 500;
  padding-top: 20px;
  padding-bottom: 0px;
  width: 200px;
}
#user-workout-table-row-type{
  border-bottom-width: 1px;
  border-color: #DEDEDE;
  font-size: 16px;
  font-weight: 500;
  padding-top: 20px;
  padding-bottom: 0px;
  width: 150px;
}
#user-workout-table-row-btn{
  border-bottom-width: 1px;
  border-color: #DEDEDE;
  font-size: 16px;
  font-weight: 500;
  padding-top: 13px;
  padding-bottom: 15px;
}
.button.unbook-btn{
  width: 600px;
  justify-content: center;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/StudioAdmin.vue